import { render, staticRenderFns } from "./tipObmen.vue?vue&type=template&id=166d51e3&scoped=true&"
import script from "./tipObmen.vue?vue&type=script&lang=js&"
export * from "./tipObmen.vue?vue&type=script&lang=js&"
import style0 from "./tipObmen.vue?vue&type=style&index=0&id=166d51e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d51e3",
  null
  
)

export default component.exports